
export default {
    getCuisineList: (data) => window.axios.post('get_cuisinelist',data)
}